// extracted by mini-css-extract-plugin
export var heroWithVideo = "HeroWithVideo-module--heroWithVideo--2_8k_";
export var headlineWrapper = "HeroWithVideo-module--headlineWrapper--3w09I";
export var content = "HeroWithVideo-module--content--2qXL1";
export var cta = "HeroWithVideo-module--cta--3aDeH";
export var contentWrapper = "HeroWithVideo-module--contentWrapper--1gst2";
export var video = "HeroWithVideo-module--video--2S-ce";